import { Component } from '@angular/core';

@Component({
  selector: 'app-item-tool',
  template: ``,
  styleUrls: []
})
export class ItemToolComponent {

}
